import { createContext } from 'react';

export interface CopyToClipboardConfigContextValue {
  onCopySuccess?: () => void;
}

export const CopyToClipboardConfigContext =
  createContext<CopyToClipboardConfigContextValue>({});
